// Add thead th text content as data-attributes.
// We can display these as pseudo elements via CSS later on for small screens
// @see build/src/scss/_1-atoms/_tabular.scss

class Table {
  constructor() {
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    const tables = document.querySelectorAll('.c-table');

    if (tables) {
      tables.forEach((table) => {
        const headCells = table.querySelectorAll('thead th');

        if (headCells.length > 2) {
          const rows = table.querySelectorAll('tr');

          rows.forEach((row) => {
            const cells = row.querySelectorAll('td, th');

            cells.forEach((cell, index) => {
              cell.setAttribute('data-th', headCells[index].textContent);
            });
          });

          table.classList.add('responsive-table');
        }
      });
    }
  }
}

export default new Table();
